import { Box, IconButton, Snackbar } from '@material-ui/core';
import { FileCopyTwoTone } from '@material-ui/icons';
import React, { cloneElement, isValidElement, useState } from 'react';
import { useTranslate } from 'react-admin';

const CopyButton = ({ trigger, content, onClick, sx, ...otherProps }) => {
  const t = useTranslate();
  const [open, setOpen] = useState(false);

  const handleCopy = (e) => {
    e.preventDefault();
    onClick?.();
    setOpen(true);
    navigator.clipboard.writeText(content);
  };

  return (
    <>
      {isValidElement(trigger) ? (
        cloneElement(trigger, {
          onClick: handleCopy,
        })
      ) : (
        <Box
          component={IconButton}
          minWidth={30}
          sx={{
            '& svg': {
              width: 18,
            },
            ...sx,
          }}
          {...otherProps}
          onClick={handleCopy}
        >
          <FileCopyTwoTone />
        </Box>
      )}
      <Snackbar
        message={t('common.text.copied')}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        autoHideDuration={1000}
        onClose={() => setOpen(false)}
        open={open}
      />
    </>
  );
};

export default CopyButton;
